import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    // console.log("not auth ");
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  // console.log('to, from, next', to, from, next);
  if (store.getters.isAuthenticated) {
    // console.log('is Authenticated ', store.getters.isAuthenticated);
    next();
    return;
  }
  if (!store.getters.isAuthenticated) {
    // console.log("not auth ");
    next("/");
    return;
  }
};
const ifAdmin = (to, from, next) => {
  if (store.getters.isAdmin ) {
    next();
    return;
  }
  if (!store.getters.isAdmin) {
    // console.log("not admin ");
    next("/");
    return;
  }
};

const routes = [
  {
    path: "/",
    name: "cabinet",
    component: () => import("@/views/Accounts.vue"),
    ifNotAuthenticated,
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/views/Admin.vue"),
    beforeEnter: ifAuthenticated, ifAdmin
  },
  {
    path: "/account/:id",
    name: "account",
    component: () => import("@/views/Account.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "חזרה לעמוד ראשי",
      resource: "account",
      breadCrumb: "חזרה לעמוד ראשי",
    },
    children: [
      {
        path: "profile",
        name: "profile",
        component: () => import("@/components/Account/AccountDetails.vue"),
      },
      {
        path: "payments",
        component: () => import("@/components/Account/AccountPayments.vue"),
      },
     
      {
        path: "paymentMethod",
        component: () =>
          import("@/components/Account/Payments/PaymentMethods.vue"),
      },
      {
        path: "users",
        name: "users",
        component: () => import("@/components/Account/AccountSubscribers.vue"),
        meta: {
          title: "ניהול מנויים",
          resource: "account",
          breadCrumb: "ניהול מנויים",
        },
      },
      {
        path: "addNewSim",
        component: () =>
          import("@/components/CommonComponents/Forms/NewSimActivation.vue"),
      },
    ],
  },
  {
    path: "/user/:id",
    name: "user",
    component: () => import("@/views/User.vue"),
    beforeEnter: ifAuthenticated, //userName,
    meta: {
      title: "ניהול מנוי",
      resource: store.getters.getUserProfile,
      breadCrumb: "ניהול מנוי",
    },
    children: [
      {
        path: "profile",
        name: "user-profile",
        component: () => import("@/components/User/UserDetails.vue"),
      },
      {
        path: "callSettings",
        name: "callSettings",
        // component: () => import("@/components/Account/AccountCalls.vue"),
                component: () => import("@/views/CallSettings.vue"),
        children: [
          {
            path: "callReports",
            name: "call-reports",
            component: () =>
              import("@/components/User/UserReports"),
          },
          {
            path: "voicemail",
            name: "voicemail",
            component: () =>
              import("@/components/Settings/Calls/Voicemail"),
          },
          {
            path: "callRecord",
            name: "call-record",
            component: () =>
              import("@/components/Settings/Calls/CallRecord"),
          },
          {
            path: "privateCaller",
            name: "private-caller",
            component: () =>
              import("@/components/Settings/Calls/PrivateCaller"),
          },
          {
            path: "callSettings",
            name: "call-settings",
            component: () =>
              import("@/components/Settings/Calls/CallSettings"),
          },
          {
            path: "callerIds",
            name: "caller-ids",
            component: () =>
              import("@/components/Settings/Calls/CallerIdsSettings"),
          },

        ]
      },
      {
        path: "dids",
        name: "dids",
        component: () =>
          import("@/components/User/UserDIDs/SubscriberDIDs.vue"),
      },
      {
        path: "subscriptions",
        component: () =>
          import(
            "@/components/User/Subscriptions/UserSubscriptionsManager.vue"
          ),
      },
      {
        path: "did/:id",
        name: "did",
        component: () => import("@/views/DID.vue"),
      },
      {
        path: "device",
        component: () => import("@/components/User/UserDevices/UserDevice.vue"),
      },
      {
        path: "roaming",
        component: () => import("@/views/Roaming.vue"),
        children: [
          {
            path: "addCalls",
            name: "add-calls",
            component: () =>
              import("@/components/User/Subscriptions/InternationalCallsPack"),
          },
          {
            path: "addRoaming",
            name: "add-roaming",
            component: () =>
              import("@/components/User/Subscriptions/NewRoamingPack"),
          },
          {
            path: "addNumber",
            name: "add-number",
            component: () => import("@/components/User/UserDIDs/ExtraDidAdding"),
          },
          {
            path: "subscriptions",
            name: "roaming-subscriptions",
            component: () => import( "@/components/User/Subscriptions/UserRoamingSubscriptions.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history", 
  base: process.env.BASE_URL,
  routes,
});

export default router;
